// src/utils/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
});

// Request interceptor - reset idle timer on any API call (counts as activity)
api.interceptors.request.use(config => {
  window.dispatchEvent(new Event('numa_activity'));
  return config;
});

// Response interceptor - handle 401/403 globally
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('numa_token');
      localStorage.removeItem('numa_staff');
      delete api.defaults.headers.common['Authorization'];
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
